<template>
  <b-container fluid class="landing">
    <b-row align-h="center" class="w-100 h-100">
      <b-col sm="8">
        <img v-if="!embed" class="brand"
          :src="require('../assets/goto-brand.svg')" />

        <g2w-link-form :initialValue="g2wLink"></g2w-link-form>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import G2wLinkForm from '@/components/g2w-link-form';

const Landing = {
  name: 'Landing',

  data() {
    return {
      g2wLink: ''
    };
  },

  components: {
    G2wLinkForm
  },

  computed: {
    embed() {
      return this.$store.state.embed;
    }
  },

  created() {
    this.logger.log('created');
    this.resetStore();

    if (this.$route.query.g2wLink) {
      this.g2wLink = this.$route.query.g2wLink;
    }
  },

  methods: {
    resetStore() {
      const dynamicModules = [
        'g2wWebinar',
        'g2wRegistration',
        'g2wSession',
        'mcsComm',
        'rtcgw',
        'g2wLive',
        'g2wBroadcast',
        'g2wSimulive',
        'survey',
        'recording'
      ];

      dynamicModules.forEach((dynamicModule) => {
        if (this.$store.state[dynamicModule]) {
          this.$store.unregisterModule(dynamicModule);
        }
      });

      this.logger.log('state keys after store reset', Object.keys(this.$store.state));
    }
  }
};

export default Landing;
</script>

<style lang="sass">

  $default-g2w-color: rgb(17, 76, 127)

  .landing
    display: flex
    flex-direction: column
    align-items: center
    margin-top: 50px
    color: $default-g2w-color

    .daisy
      height: 100px
      width: 100px

    .brand
      max-width: 300px
      margin-left: -20px

</style>
